import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { mixtura } from './../../../shared/object/mixtura.model';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { AgregarEditarMixturaComponent } from './agregar-editar-mixtura/agregar-editar-mixtura.component';
import { MixturaService } from 'src/app/services/mixtura.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ToastService } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-mixtura',
  templateUrl: './mixtura.component.html',
  styleUrls: ['./mixtura.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class MixturaComponent implements OnInit {
  formulario: FormGroup;

  MixturaList: mixtura[];
  mixtura: mixtura;
  selectMixtura: mixtura;

  public nombre: string;
  public codigo: number;
  public codgo_modulo: number = 9;
  public rut_usuario = Number(this.accesolocalstorage.getRutUsuario());

  @ViewChild(AgregarEditarMixturaComponent, { static: true }) modalAgregarEditarMixtura: AgregarEditarMixturaComponent;

  constructor(
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService,
    private mixturaService: MixturaService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.buscar(1);
  }

  EditMixtura(mixtura: mixtura) {
    this.modalAgregarEditarMixtura.load(mixtura);
  }

  showModalAgregar() {
    this.modalAgregarEditarMixtura.show();
  }

  //ACTUALIZAR LA VISTA
  buscar(pageNumber: number) {
    this.selectMixtura = {
      codigo: null,
      nombre: '',
      activado: true,
      fecha_registro: new Date(),
    };

    this.MixturaList = [];
    // console.log(this.formHeader.get('rutCliente').value);
    const inputParams = { entidad: this.selectMixtura };

    this.mixturaService.obtenerSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.MixturaList = registros;
    });
  }

  permitirCambioEstado(mixtura: mixtura) {
    if (mixtura.activado) {
      mixtura.activado = false;
    } else {
      mixtura.activado = true;
    }

    const inputParams = {
      entidad: {
        activado: mixtura.activado,
        codigo: mixtura.codigo,
        nombre: mixtura.nombre,
      },
    };

    this.mixturaService.EditarMixtura(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.toastService.success('Operación exitosa');
      this.buscar(1);
    });
  }
}
